import React from "react";
import cn from "classnames";
import styles from "./Timeline.module.sass";

/**
 * Timeline vertical (sale de la ficha de cliente de Subscriptions).
 * `items = [{ date, sub?, what, color?, next? }]`; `next` pinta el hito futuro
 * con el punto discontinuo.
 */
const Timeline = ({ items }) => (
  <div className={styles.tl2}>
    {items.map((it, i) => (
      <div key={it.key ?? i} className={cn(styles.tl2Item, { [styles.tl2Next]: it.next })}>
        <span className={styles.tl2Dot} style={!it.next && it.color ? { background: it.color } : undefined} />
        <div className={styles.tl2Date}>
          {it.date}
          {it.sub ? <div className={styles.muted}>{it.sub}</div> : null}
        </div>
        <div className={styles.tl2What}>{it.what}</div>
      </div>
    ))}
  </div>
);

export default Timeline;
